import config from './api/config';

window.onerror = function(message,source,line,column,error) {
    // if (config.debug) {
    //     alert("window.🚩：", { message, source, line, column, error })
    // }
    console.error("window.🚩：", { message, source, line, column, error })
}

import { createApp } from 'vue'
import { createPinia } from 'pinia'
//持久化存储
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import { router } from './router'
//多语言
import i18n from './languages/index';
const app = createApp(App);

//pinia存储
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
//多语言
app.use(i18n)

//router
app.use(router)

if (import.meta.env.PROD) {
  app.config.warnHandler = () => {};
}
//监听全局报错
// app.config.errorHandler = (err, vm, info) => {
//     // if (config.debug) {
//     //     alert("🚩：", {"name": err.name, "message": err.message, info})
//     // }
//     console.error("🚩：", {"name": err.name, "message": err.message, info})
//     throw err
// }

//启动
app.mount('#app')
